import { useState } from "react";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Modal } from "antd";
import { FirmaCanvas } from "./FirmaCanvas";
import styles from "../../shared/Evaluaciones.module.css";

export function ModalFirmas({ firmante, guardando, onCerrar, onGuardar }) {
  const [imagen, setImagen] = useState(null);

  return (
    <Modal
      className={styles.signatureModal}
      open
      onCancel={onCerrar}
      footer={null}
      width={640}
      centered
      destroyOnClose
      maskClosable={false}
      closable={!guardando}
      keyboard={!guardando}
      title={null}
    >
      <div className={styles.signatureIntro}>
        <span className={styles.label}>FIRMA / EVALUACIÓN</span>
        <h2>Firma de {firmante.rol}</h2>
      </div>
      <div className={styles.signatureCapture}>
        <FirmaCanvas
          rol={firmante.rol}
          nombre={firmante.usuarioID}
          onChange={setImagen}
        />
      </div>
      <div className={styles.signatureActions}>
        <Button onClick={onCerrar} disabled={guardando}>Volver</Button>
        <Button
          type="primary"
          onClick={() => onGuardar(imagen)}
          loading={guardando}
          disabled={!imagen}
        >
          Guardar firma <ArrowRightOutlined />
        </Button>
      </div>
    </Modal>
  );
}
